"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlActiveMembershipsValidation = void 0;
const MembershipTransactionValidation_1 = require("./MembershipTransactionValidation");
class PaymentTerminalControlActiveMembershipsValidation {
    static isValid(entity) {
        // Validate entity.memberships for existence and correct type.
        if (entity.memberships == undefined)
            return false;
        if (!Array.isArray(entity.memberships))
            return false;
        if (!entity.memberships.every((elem) => {
            if (!MembershipTransactionValidation_1.MembershipTransactionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.PaymentTerminalControlActiveMembershipsValidation = PaymentTerminalControlActiveMembershipsValidation;
